// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 356) return "static/chunks/356-b473667313d09e93.js";
	if (chunkId === 810) return "static/chunks/810-8576b52c5b62db78.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 600 ? "05f6971a" : chunkId) + "." + {"7":"5c401e269b429190","123":"1b6c42d61b2ae243","331":"04d5db4cc2d66a2c","600":"a53d529ab97a4fab","678":"316591a08e80468e"}[chunkId] + ".js";
};